<!DOCTYPE html>
<head>
	<meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
</head>
<template>
	<div id="app" :class="loggedIn ? 'app-shell' : 'app-fullwidth'">
		<app-sidebar v-if="loggedIn" :open="sidebarOpen" @close="sidebarOpen = false" />
		<div
			v-if="loggedIn && sidebarOpen"
			class="sidebar-backdrop"
			aria-hidden="true"
			@click="sidebarOpen = false"
		/>
		<div class="app-content">
			<header
				class="content-header"
				:class="{ 'content-header--no-title': !$route.meta.title }"
				v-if="loggedIn"
				role="banner"
			>
				<button
					class="sidebar-toggle"
					@click="sidebarOpen = !sidebarOpen"
					:aria-expanded="sidebarOpen.toString()"
					aria-controls="app-sidebar"
					aria-label="Toggle navigation"
				>
					<b-icon :icon="sidebarOpen ? 'x-lg' : 'list'" font-scale="1.25" aria-hidden="true" />
				</button>
				<h1 v-if="$route.meta.title" class="content-header__title">{{ $route.meta.title }}</h1>
			</header>
			<div class="content-body">
				<router-view />
			</div>
		</div>
	</div>
</template>

<style lang="scss">
	@import './assets/scss/main.scss';

	#app {
		font-family: var(--secudoc-font-body);
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: var(--secudoc-on-surface);
		background-color: var(--secudoc-background);
		min-height: 100vh;
	}

	.app-shell {
		display: flex;
		min-height: 100vh;
	}

	.app-content {
		flex: 1;
		min-width: 0;       /* prevents flexbox blowout */
		overflow-y: auto;
		display: flex;
		flex-direction: column;
	}

	.app-fullwidth .app-content {
		width: 100%;
	}

	.content-header {
		height: 60px;
		display: flex;
		align-items: center;
		padding: 0 var(--secudoc-space-6);
		border-bottom: 1px solid var(--secudoc-outline);
		background-color: var(--secudoc-surface);
		position: sticky;
		top: 0;
		z-index: 10;
		flex-shrink: 0;
	}

	.content-header__title {
		font-family: var(--secudoc-font-brand);
		font-size: 1.125rem;
		font-weight: 600;
		color: var(--secudoc-on-surface);
		margin: 0;
	}

	.content-body {
		flex: 1;
	}

	/* Hamburger toggle — hidden on desktop, visible on mobile */
	.sidebar-toggle {
		display: none;
		background: none;
		border: none;
		padding: var(--secudoc-space-2);
		margin-right: var(--secudoc-space-3);
		color: var(--secudoc-on-surface);
		cursor: pointer;
		border-radius: 4px;
		line-height: 1;
		flex-shrink: 0;

		&:hover,
		&:focus {
			background-color: var(--secudoc-surface-variant);
			outline: none;
		}
	}

	/* Semi-transparent backdrop behind the open drawer */
	.sidebar-backdrop {
		position: fixed;
		inset: 0;
		background: rgba(0, 0, 0, 0.4);
		z-index: 1039;
	}

	@media (max-width: 767.98px) {
		/* Switch shell from flex-row to block so fixed sidebar doesn't steal layout space */
		.app-shell {
			display: block;
		}

		.sidebar-toggle {
			display: flex;
			align-items: center;
			justify-content: center;
		}

		/* Header without a route title still needs to show for the hamburger on mobile */
		.content-header--no-title {
			border-bottom: none;
		}
	}

	/* On desktop, suppress the title-less header entirely */
	@media (min-width: 768px) {
		.content-header--no-title {
			display: none;
		}
	}
</style>

<script>
	import firebase from "firebase/compat/app";
	import "firebase/compat/auth";
	import AppSidebar from "@/components/app-sidebar";

	export default {
		created() {
			firebase.auth().onAuthStateChanged(user => {
				if (user) {
					this.loggedIn = true;
				} else {
					this.loggedIn = false;
					this.sidebarOpen = false;
				}
			}, error => {
				console.error(error);
			});
		},
		components: { 'app-sidebar': AppSidebar },
		data() {
			return {
				loggedIn: false,
				sidebarOpen: false,
			}
		},
		watch: {
			$route() {
				this.sidebarOpen = false;
			}
		}
	}
</script>
